import { RegionLandingPage } from "./RegionLandingPage";
import { landingPages } from "./registry";

const entry = landingPages.find((p) => p.slug === "us-east-coast")!;

export function UsEastCoastPage() {
  return <RegionLandingPage regionKey={entry.regionKey} tag={entry.tag} />;
}
